/*
 * @Author: gongzhizhen
 * @Date: 2019-05-29 10:13:27
 * @LastEditTime: 2019-06-27 14:29:25
 * @LastEditors: gongzhizhen
 */
import React, { PureComponent } from 'react';
import { Input, Button, Modal } from 'neatui';
import Captcha from '../captcha';
import ajax from '../../util/ajax';
import { connect } from 'react-redux';
import action from '../../reduxModules/action';
import { bindActionCreators } from 'redux';

class PhoneValidation extends PureComponent {
  state = {
    // captchaCode: '',
    time: 61,
    validPeriod: false,
  };

  componentWillUnmount() {
    this.unMount = true;
  }

  getPuzzle = data => {
    const { updatePhoneCaptchaCode } = this.props;
    // 原有state方式，会造成react报错，组件unmount后，不能再设置state，有内存泄露风险。所以改为存在store中
    updatePhoneCaptchaCode('captchaCode', data.validate);
    // this.setState({
    //   captchaCode: data.validate,
    // });
  };

  countDown = () => {
    const { time } = this.state;
    if (this.unMount) {
      return;
    }
    if (time == 0) {
      this.captcha.refresh();
    }
    if (time <= 0) {
      this.setState({
        time: 61,
      });
    } else {
      this.setState(state => ({
        time: state.time - 1,
      }));
      setTimeout(this.countDown, 1000);
    }
  };

  getCode = () => {
    const { verifyPhone, captchaCode } = this.props;
    // const { captchaCode } = this.state;
    if (!captchaCode) {
      Modal.error({
        title: '操作错误',
        content: '请先完成左侧拼图验证！'
      })
      return
    }
    return ajax(
      'msg/verify/sendMesgCode.do',
      {
        data: { verifyPhone, NECaptchaValidate: captchaCode },
        method: 'POST',
        // dataType: 'json',
      },
      () => {
        this.countDown();
        // if (this.captcha) this.captcha.refresh();
      },
    );
  };

  handleLoad = el => {
    this.captcha = el;
  };

  handleBlur = e => {
    const { onBlur, verifyPhone } = this.props;
    const { time } = this.state;
    if (onBlur && time < 61) {
      onBlur({ verifyPhone, verifyCode: e.target.value });
    }
  };

  render() {
    const { time } = this.state;
    const { onChange, captchaCode } = this.props;
    return (
      <div className="phoneValidation">
        <Captcha done={this.getPuzzle} mode="float" onLoad={this.handleLoad} />
        <Input size="large" onBlur={this.handleBlur} onChange={onChange} />
        <Button disabled={time <= 60} onClick={this.getCode}>
          {time > 60 ? '获取验证码' : `重新获取(${time}s)`}
        </Button>
      </div>
    );
  }
}


export default connect(
  state => ({
    captchaCode: state.phoneCaptchaCode.captchaCode,
  }),
  dispatch =>
    bindActionCreators(
      {
        updatePhoneCaptchaCode: action.updatePhoneCaptchaCode,
      },
      dispatch,
    ),
)(PhoneValidation);
